export const onlyDigits = (value: string) => value.replace(/[\D]/g, "")

export const uppercase = (value: string) => value.toUpperCase()

export const kba = (value: string) => value.toUpperCase().replace(/[^A-Z0-9 ]/g, "")
